import { useContext, useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, 
        Grid, 
       TextField } from '@material-ui/core';
import { useMutation,useLazyQuery } from '@apollo/client';
import CircularProgress from '@mui/material/CircularProgress';
import ObjectivesContext, { Types } from "../../../context/ObjectiveContext/ObjectiveContext";
import AddTable from '../../../screens/Colaboradores/Colaboradores/CollaboratorTab/AddTable';
import InputAdornment from '@mui/material/InputAdornment';

import { GET_OBJECTIVE_EVIDENCE,
        UPDATE_OBJECTIVE_EVIDENCE,
        NOTIFY_COLLABORATOR_EVIDENCES
      } from '../../../Querys/querys';
import { uploadEvidenceFile } from '../../../services/objectiveService';
import Plus from "../../../assets/svg/plus.svg";
import { ErrorAlert } from "../../../alerts/errorAlert";
import {WarningAlert} from "../../../alerts/WarningAlert";
import styles from '../Objectives.module.css';
import { SuccessfulAlert } from '../../../alerts/successAlerts';
import TableEvidences from './TableEvidences';
import UploadImage from "../../../assets/svg/uploadImage.svg";
import { TruncateText,formatTextMin} from '../../../helpers/TruncateText';

const sanitize = require("sanitize-filename");

const AddEvidenceModal = () => {
  const { state, dispatch } = useContext(ObjectivesContext);
  const [idImg, setIdImg] = useState(0)
  const [viewLoad, setViewLoad] = useState(false)
  const [disabledBtn, setDisabledBtn] = useState(false)
  const [arrayEvidence, setArrayEvidence] =  useState<any[]>([])  
  const [sumPercentajeEvindence , setSumPercentajeEvindence] = useState(0);
  const [sumProgressEvindence , setSumProgressEvindence] = useState(0);
  const [notifyCollaborator] = useMutation(NOTIFY_COLLABORATOR_EVIDENCES); 
  const [editObjective] = useMutation(UPDATE_OBJECTIVE_EVIDENCE,{		
  fetchPolicy: 'no-cache',
  onCompleted({ UPDATE_OBJECTIVE_EVIDENCE }) { },}); 
 
  const [objectivesEvidence] = useLazyQuery(GET_OBJECTIVE_EVIDENCE, {
		fetchPolicy: 'no-cache',
		onCompleted({ GET_OBJECTIVE_EVIDENCE }) { 
       if(GET_OBJECTIVE_EVIDENCE.length>0){        
        setArrayEvidence(GET_OBJECTIVE_EVIDENCE)         
        let sumPercentaje = GET_OBJECTIVE_EVIDENCE.reduce((acum: any, result: any) => acum + result.result, 0);     
        let sumProgress = GET_OBJECTIVE_EVIDENCE.reduce((acum: any, result: any) => acum + result.progress, 0);  
        const newValue = sumPercentaje >= 100 && sumPercentaje < 101 ? Math.floor(sumPercentaje) : sumPercentaje;   
        setSumPercentajeEvindence(newValue)
        setSumProgressEvindence(sumProgress)
        setViewLoad(false)
      }	else{
        setArrayEvidence([])      
        setSumPercentajeEvindence(0)
        setSumProgressEvindence(0)
        setViewLoad(false)
      }		
		},
	});

  useEffect(() => {  
    if(state?.selectedObjective?.id !== null){
      objectivesEvidence({ 
        variables: {
          input: {
            id: parseInt(state?.selectedObjective?.id as any, 10),
          }
        }})
    }  
   }, [objectivesEvidence, state?.selectedObjective]);

  const [form, setForm] = useState<any>({
    name: "",
    nameIndicator: "",
    metricObjective: "",
    metricIndicator: "",
    weight: "",
    description: "",
    progress: 0,
  });

  const [result, setResult] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [evaluation, setEvaluation] = useState<string>("");
  const [txtImagen,setTxtImagen]=useState<string>("Evidencia")
  const [archives, setArchives] = useState<string>("")
  const inputRef:any = useRef(null);

  useEffect(() => {
    if (state.selectedObjective) {      
      setForm({
        name: state.selectedObjective.ObjectiveName,
        nameIndicator: state.selectedObjective.nameIndicator,
        metricObjective: state.selectedObjective.metricObjective,
        metricIndicator: state.selectedObjective.metricIndicator,
        weight: state.selectedObjective.weight?.toString() + "",
        description: state.selectedObjective.descriptionIndicator || "",       
        progress:  0,
      });
      setEvaluation(state.selectedObjective.evaluation || "");
      setResult(state.selectedObjective.result || 0);
    }
  }, [state.selectedObjective]);

  const cancelButton =async () => {    
    dispatch({ type: Types.CLEAR_SELECTED_OBJECTIVE });
    dispatch({ type: Types.CANCEL_ADD_EVIDENCE_MODAL });
    dispatch({ type: Types.CANCEL_EVALUATE_OBJECTIVE_MODAL });
    setForm({
      name: "",
      nameIndicator: "",
      metricObjective: "",
      metricIndicator: "",
      weight: "",
      description: "",
    });
    setSumPercentajeEvindence(0)
    setSumProgressEvindence(0)
    setArrayEvidence([])
    setIdImg(0) 
    setDisabledBtn(true)
    setTxtImagen('Evidencia');           
  }
    
  const updateProgressForm = (e: any) => {    
    let value = parseFloat(e.target.value.replace("$", "").replaceAll(",", "").replace("%", "").replaceAll(",", "")) || 0;
    if (isNaN(value) || value < 0) value = 0;
    let objectiveString = state.selectedObjective?.metricObjective.toString().replace("$", "").replaceAll(",", "").replace("%", "").replaceAll(",", "") || '';
    let objective = parseFloat(objectiveString ?? '');
    let progressBD = sumProgressEvindence;
    if (progressBD === 0) {
      if (value > objective) value = objective;
      const resultValue = value / objective;
      setForm({ ...form, progress: value });
      const res = resultValue * 100;
      setResult(Number(res.toFixed(2)));
    } else {      
      let res = (objective -sumProgressEvindence);   
      if (value > res) value = res;      
       setForm({ ...form, progress: value });      
      const resultValue = value / res;      
      let percentage = 100 - sumPercentajeEvindence;
      const resNew = resultValue * percentage;      
      let resOk = isNaN(resNew) ? 100 : resNew;      
      setResult(Number(resOk.toFixed(2)));
    }
  };


  const onChangeImage = async (e: any) => {      
    setTxtImagen(e.target.files[0].name);
    setArchives(e.target.files[0]);     
  }

  const sendReminder = async () => {
   const resNotify= await notifyCollaborator({
      variables: {
        input: {
          campaignId: parseInt(state.campaign?.id as string, 10),
          collaboratorId: state.collaboratorId
        }
      }
    })
    if(resNotify?.data?.NOTIFY_COLLABORATOR_EVIDENCES === 'SinLider'){
      return ErrorAlert({ text: 'No tiene  un líder asignado que notificar ' }) 
    }else{
      SuccessfulAlert({ text: "Se ha enviado el recordatorio de evidencias" })
    }
    
  }

  const handleSaveEvidence = async () => {
    try {
      if (formatTextMin(txtImagen) === formatTextMin('Evidencia'))  return ErrorAlert({ text: 'Es necesario agregar la evidencia' }) 
      setViewLoad(true)             
      const idFileRes: any = await uploadEvidenceFile(
        archives,
        state.selectedObjective?.id as any,
        state.selectedObjective?.idCollaborator?.toString() as any,
        await sanitize(txtImagen)
      );      
      const fileId = parseInt(idFileRes?.data?.id, 10);
      if (!fileId) throw new Error("Error al obtener el ID de la imagen");  
      setIdImg(fileId);    
      if(sumPercentajeEvindence === 100.00){
        WarningAlert({ text: 'Seguirá cargando Evidencia aun cuando ha llegado al 100%  del objetivo' });
        await editObjective({
          variables: {
            input: {             
              objectiveId:fileId,              
              progress: 0,
              result: 0,
            }
          }
        });
      }
      else{
      await editObjective({
        variables: {
          input: {
            objectiveId: fileId,
            progress: parseInt(form.progress, 10),
            result: result,
          },
        },
      });         
    }  

    await objectivesEvidence({
      variables: {
        input: {
          id: parseInt(state.selectedObjective?.id as any, 10),
        },
      },
    });      

     setTxtImagen('Evidencia');  
     setIdImg(0)
     setResult(0)     
     setForm((prevForm:any) => ({
       ...prevForm,
       progress: 0,
     }));   
    } catch (error) {
      console.error("Error en handleSaveEvidence:", error);
    }
  };

  useEffect(() => {
    
  }, [form]);
  

  return (
    
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={state.addEvidenceModal || state.evaluateObjectiveModal}
      fullWidth={true}    
    >    
      <h2 id="form-dialog-title" className="text-center">
        {form.name} 
      </h2>
      <DialogContent>
        <Grid direction="row" container spacing={2}>
          <Grid xs item>
            <TextField
              name="metricName"
              defaultValue={form.nameIndicator}
              label="Nombre del indicador"
              variant="outlined"
              size="small"
              fullWidth={true}
              InputProps={{
                readOnly: true,
              }}
              disabled
            />
          </Grid>
          <Grid xs item>
            <TextField
              name="metricName"
              defaultValue={form.metricIndicator}
              label="Métrica objetivo"
              variant="outlined"
              size="small"
              fullWidth={true}
              InputProps={{
                readOnly: true,
              }}
              disabled
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogContent>
        <Grid direction="row" container spacing={2}>
          <Grid xs item>
            <TextField
              name="metricName"
              defaultValue={form.metricObjective}
              label="Indicador"
              variant="outlined"
              size="small"
              fullWidth={true}
              InputProps={{
                readOnly: true,
              }}
              disabled
            />
          </Grid>
          <Grid xs item>
            <TextField
              name="metricName"
              defaultValue={form.weight}
              label="Peso"
              variant="outlined"
              size="small"
              fullWidth={true}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              disabled
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogContent>       
        <Grid xs item>
          <TextField
            name="name"
            value={form.description}
            label="Descripción del objetivo"
            variant="outlined"
            multiline
            size="small"
            rows={3}  
            fullWidth={true}
            InputProps={{
              readOnly: true,
            }}
            disabled
          />
        </Grid>
      </DialogContent>  
      {
        (state?.campaign?.step!=='definicion' && arrayEvidence.length > 0 ) &&
        <DialogContent className={styles.tableEvidences}>
            <h4 id="form-dialog-title" className="text-center">
              Evidencias
              {arrayEvidence.length > 0  && (
                <span>{` (${arrayEvidence.length})`}</span>
              )}
            </h4> 
            {viewLoad ?
            <div id="form-dialog-title" className="text-center"> <CircularProgress/></div>
            :(<></>)
            }
            <TableEvidences 
             data={arrayEvidence} 
             setDisabledBtn={setDisabledBtn}
             setViewLoad={setViewLoad}
             arrayEvidence={arrayEvidence}
             setArrayEvidence={setArrayEvidence}
             setSumPercentajeEvindence={setSumPercentajeEvindence} 
             setSumProgressEvindence={setSumProgressEvindence}            
             />      
        </DialogContent>
      }

      {
        state.addEvidenceModal && (
          <>
           <DialogContent className={styles.evidenceActions}>
               <DialogContent className={styles.containerUploadImgGoals}>                   
                    <label className={styles.customFileUploadImageGoals} id="lblImage">
                      <p className={styles.textLblImgEvidence}> {TruncateText(txtImagen,10) }</p>
                       <input ref={inputRef}
                              type="file" name="Image"
                              className={styles.inputFileGoals}                           
                              onChange={(e) => onChangeImage(e)} 
                              accept=".pdf, .jpg, .jpeg, .png, .docx, .xlsx, .mp4, .zip"
                        />
                        <img  id="imgGoal" src={UploadImage} alt="imgGoals"  />                          
                     </label>             
                </DialogContent>      
              <DialogContent className={styles.ContainerMetricTxt} >
              <TextField
                  name="metricName"
                  value={form.progress} // Sin símbolos para evitar errores en edición
                  label="Progreso"
                  variant="outlined"
                  size="small"
                  type="text"
                  onChange={(event) => {
                    const newValue = event.target.value;
                    if (/^[0-9.]*$/.test(newValue)) {
                      updateProgressForm(event);
                    }
                  }}
                  InputProps={{
                    startAdornment: state?.selectedObjective?.metricIndicator === "pesos" ? <InputAdornment position="start">$</InputAdornment> : null,
                    endAdornment: state?.selectedObjective?.metricIndicator === "porcentaje" ? <InputAdornment position="end">%</InputAdornment> : null
                  }}
                />           
              </DialogContent>
              <DialogContent className={styles.ContainerProgress}>
               <span className={styles.progress}>
                {result} 
               </span> %
              </DialogContent>
              <DialogContent 
                className={styles.PlusEvidence}
                onClick={handleSaveEvidence}
              >
                 <button className={styles.btnAddEvidence} >
                  <div className="infobtnAddEvidence">
                          <div><img src={Plus} alt="plus"/> </div>          
                  </div>                   
                </button>    
              </DialogContent>
            </DialogContent>

            <DialogContent className={styles.evidenceCancelContainer}>
              <button
                onClick={cancelButton}
                className={styles.evidenceCancelButton}
              >Cerrar</button>
              {/* <Button text="Aceptar" func={updateProgress} /> */}
            </DialogContent>
          </>
        )
      }   
    
      {
        state.evaluateObjectiveModal && (
          <DialogContent className={styles.evidenceCancelContainer}>
            <button
              onClick={cancelButton}
              className={styles.evidenceCancelButton}
            >
            {state?.campaign?.status === 'finalizado' ? 'Cerrar' : 'Cancelar'}</button>
            {
              state?.campaign?.step !== 'definir' &&(state.rol==='admin' || state.rol==='leader') && (
                <AddTable
                  func={sendReminder}
                  text="Recordatorio"
                  img="add-icon.svg"
                />
              )
            }            
          </DialogContent>
        )
      }   
    </Dialog>    
  );
};

export default AddEvidenceModal;
